// Palette

export default {
  underline: {
    '&.Mui-disabled:before': {
      borderBottomStyle: 'none'
    }
  }
};
